module.exports = __WEBPACK_EXTERNAL_MODULE_237__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Pikaday","commonjs2":"pikaday","commonjs":"pikaday","amd":"pikaday"}
// module id = 237
// module chunks = 0